import { Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    projects: [
      { label: 'Rain Nova', href: '#' },
      { label: 'Nida Park Evleri', href: '#' },
      { label: 'Şehr-i Emin Konutları-3', href: '#' },
      { label: 'Şehr-i Emin Konutları-4', href: '#' },
      { label: 'Baran-75 Konutları', href: '#' },
    ],
    info: [
      { label: 'Hakkımızda', href: '#about' },
      { label: 'İletişim', href: '#contact' },
    ],
    legal: [
      { label: 'Gizlilik Politikası', href: '#' },
      { label: 'Kullanım Şartları', href: '#' },
      { label: 'KVKK Aydınlatma Metni', href: '/kvkk.html' },
      { label: 'Çerez Politikası', href: '#' },
    ],
  };

  const socialLinks = [
    { icon: Facebook, href: 'https://www.facebook.com/meetinkentseldonusumveproje/', label: 'Facebook' },
    { icon: Instagram, href: 'https://www.instagram.com/meetin_gayrimenkul', label: 'Instagram' },
    { icon: Linkedin, href: 'https://tr.linkedin.com/company/meetin-kentseldonusum-proje', label: 'LinkedIn' },
    { icon: Youtube, href: 'https://www.youtube.com/@Meetinkentsel', label: 'YouTube' },
  ];

  return (
    <footer className="bg-gradient-to-br from-slate-950 to-slate-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <h3 className="text-3xl font-bold text-white mb-4">
              Rain Nova
            </h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              İstanbul'un prestijli konut projesi Rain Nova ile lüks ve konforu bir arada
              yaşayın. Modern mimari anlayışı ile hayalinizdeki eve kavuşun.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  aria-label={social.label}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-white/10 hover:bg-slate-900 dark:bg-stone-700 flex items-center justify-center transition-all duration-300 hover:scale-110"
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Projects */}
          <div>
            <a
              href="https://baraninsaat.com.tr/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block font-semibold text-lg mb-4 text-stone-500 hover:text-stone-200 hover:scale-105 origin-left transition-all duration-200"
            >Projelerimiz</a>
            <ul className="space-y-3">
              {footerLinks.projects.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    // inline-block + py-1: satır yüksekliği 21px olduğu için
                    // dokunma hedefi 24px eşiğinin altında kalıyordu
                    className="inline-block py-1 text-gray-300 hover:text-stone-300 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4 text-stone-500">Kurumsal</h4>
            <ul className="space-y-3">
              {footerLinks.info.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    // inline-block + py-1: satır yüksekliği 21px olduğu için
                    // dokunma hedefi 24px eşiğinin altında kalıyordu
                    className="inline-block py-1 text-gray-300 hover:text-stone-300 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-lg mb-4 text-stone-500">Yasal</h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    // inline-block + py-1: satır yüksekliği 21px olduğu için
                    // dokunma hedefi 24px eşiğinin altında kalıyordu
                    className="inline-block py-1 text-gray-300 hover:text-stone-300 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} Rain Nova. Tüm hakları saklıdır.
            </p>
            <p className="text-gray-400 text-sm text-center md:text-right">
              Prestijli Yaşamın Adresi | İstanbul, Türkiye
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
